/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}

/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
:host {
  display: inline-block;
}

.oebb-date-field {
  position: relative;
  display: inline-block;
  width: 100%;
}
.oebb-date-field input::placeholder {
  opacity: 0;
}
.oebb-date-field input:focus + .form-label-text, .oebb-date-field input:not(:placeholder-shown) + .form-label-text {
  top: 0;
  padding: 0 0.25rem;
  background: linear-gradient(to bottom, var(--form-container-bg) 50%, var(--form-input-bg) 50%);
  line-height: 1;
  font-size: var(--form-floating-size);
  letter-spacing: var(--form-floating-spacing);
}
.oebb-date-field .form-label-text {
  position: absolute;
  top: calc(var(--form-input-height) / 2);
  left: 1rem;
  transform: translateY(-50%);
  color: var(--form-input-placeholder-color);
  transition-duration: 300ms;
  z-index: 1;
}
.oebb-date-field input {
  width: 100%;
  min-height: var(--form-input-height);
  padding: 0 var(--form-input-padding-right) 0 var(--form-input-padding-left);
  border: 1px solid var(--form-input-border-color);
  border-radius: var(--form-input-border-radius);
  background: var(--form-input-bg);
  color: var(--form-input-color);
  font-family: inherit;
  font-size: inherit;
  box-sizing: border-box;
}
.oebb-date-field input::placeholder {
  color: var(--form-input-placeholder-color);
}
.oebb-date-field button {
  position: absolute;
  top: calc(var(--form-input-height) / 2);
  right: var(--form-icon-right);
  width: 1em;
  height: 1em;
  line-height: 1em;
  transform: translateY(-50%);
  font-size: var(--form-icon-size);
  color: var(--form-icon-color);
  pointer-events: none;
  cursor: pointer;
  padding: 0;
  border: none;
  background: none;
  pointer-events: initial;
}
.oebb-date-field button oebbx-icon {
  display: block;
  width: 100%;
  height: 100%;
}
.oebb-date-field button oebbx-icon svg {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.oebb-date-field path {
  fill: currentColor;
}
.oebb-date-field oebbx-calendar {
  z-index: 30;
  transform: translateY(var(--form-input-outline-width));
}
.oebb-date-field:focus-within input, .oebb-date-field input.calendar-open {
  border-color: var(--form-input-focus-border);
  outline: var(--form-input-outline-width) solid var(--form-input-outline-color);
  box-shadow: var(--form-input-box-shadow, none);
}
.oebb-date-field--invalid input {
  color: var(--form-invalid-color);
  border-color: var(--form-invalid-color);
}
.oebb-date-field--invalid .form-label-text, .oebb-date-field--invalid button {
  color: var(--form-invalid-color);
}
.oebb-date-field--invalid-message {
  color: var(--form-invalid-color);
}